import React, { useState } from 'react'
import clsx from 'clsx'
import { CircularProgress, Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { Icon } from '@iconify/react'
import { CoreButton } from 'src/components/core'
import { aICreatorUploadAttachmentSuccess } from 'src/reducers/ai-creator/action'
import { useDispatch } from 'react-redux'
import {
  componentBoxShowAction,
  componentBoxHideAction,
} from 'src/reducers/component-box/action'
import ComponentBoxContent from 'src/model/component-box'
import RecentFiles from 'src/components/recent-files'
const NonAttachmentView = props => {
  const {
    classes,
    fileInputRef,
    handleOnDropFile,
    handleFileSelect,
    attachmentLoading,
  } = props
  const dispatch = useDispatch()
  const [isHovered, setIsHovered] = useState(false)
  const onClickAttachment = () => {
    if (attachmentLoading) return
    fileInputRef.current.click()
  }
  const getRecentFile = () => {
    /**
     *
     * @param {} items
     */
    const selectRecentFiles = item => {
      dispatch(aICreatorUploadAttachmentSuccess(item, item.original_file_name))
      dispatch(componentBoxHideAction())
    }
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(
          <RecentFiles selectRecentFiles={selectRecentFiles} />,
          {
            hideCloseButton: false,
          },
        ),
      ),
    )
  }

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onDrop={handleOnDropFile}
      onDragOver={e => e.preventDefault()}
      className={clsx({
        [classes.root]: !isHovered,
        [classes.rootHover]: isHovered,
      })}
    >
      {attachmentLoading ? (
        <CircularProgress size={32} />
      ) : (
        <>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept=".pdf"
            onChange={handleFileSelect} // Handle file selection from file explorer
          />
          <Icon
            icon="proicons:file"
            className={clsx({
              [classes.icon]: !isHovered,
              [classes.iconHover]: isHovered,
            })}
          />
          <Typography fontSize={'12px'} color={'#002E47'} fontWeight={500}>
            Select from recent files or upload files from your computer
          </Typography>
          <Typography fontSize="12px" color={'#919EAB'}>
            Supported files: .pdf{' '}
          </Typography>
          <div className={classes.buttonGroup}>
            <CoreButton
              color="secondary"
              size="small"
              onClick={() => {
                getRecentFile()
              }}
            >
              Select recent file
            </CoreButton>
            <CoreButton
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => {
                fileInputRef.current.click()
              }}
            >
              Upload
            </CoreButton>
          </div>
        </>
      )}
    </div>
  )
}

export default withStyles(styles)(NonAttachmentView)
